<template>
  <section class="page--section">
    <div class="section__title">
      <el-row :gutter="10" type="flex" align="middle">
        <el-col :span="18">
          <h2>{{ $t('trainingFullLines') }}</h2>
        </el-col>
      </el-row>
    </div>


    <el-row :gutter="10">
      <el-col :md="24" :xs="24" :sm="24">
        <div
          v-for="usersCourse in certifications"
          :key="usersCourse.id">

          <training-full-line-certified-card
            :usersCourse="usersCourse"
            :course="catalogCourseForUsersCourse(usersCourse)">
          </training-full-line-certified-card>

        </div>
      </el-col>
    </el-row>


  </section>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import TrainingFullLineCertifiedCard from '@/components/training/TrainingFullLineCertifiedCard.vue';

  export default {
    props : {
      certifications : Array,
      courseCatalog  : Array,
    },
    components : {
      TrainingFullLineCertifiedCard,
    },
    methods: {
      catalogCourseForUsersCourse : function(usersCourse) {
        // return the catalog course info for a users course.
        let course = this.courseCatalog.find(catalogCourse => usersCourse.id === catalogCourse.id);
        return course;
      },
    },
  }
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>

</style>